import { z } from 'zod';
import { userCreateSchema } from './user';

export const forgotPasswordSchema = z.object({
  email: z.string().email('Invalid email').max(100),
});

export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z.object({
  token: z.string().min(1, 'Reset token is required'),
  password: userCreateSchema.shape.secret,
});

export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
